var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home pure-g"},[_c('StocktakingMenu',{staticClass:"pure-u-1-6",attrs:{"url":_vm.url}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pure-u-5-6"},[_c('div',{staticClass:"formBox"},[_c('form',{staticClass:"pure-form pure-form-stacked",attrs:{"id":"myStatisticFormBox"}},[_c('fieldset',[_c('legend',[_vm._v("Statistik")]),_c('div',{staticClass:"pure-g"})])])])])
}]

export { render, staticRenderFns }